<script>
import * as Common from '../Common.js'
import {onMount} from 'svelte'
import Chart from 'chart.js'

export let items

let chartElem
let chart

$: items && refreshCount()

onMount(async () => {
    var ctx2 = chartElem.getContext('2d');
    chart = new Chart(ctx2, {
            type: 'line',
            data: {},
            options: {
                legend: {
                    display: false
                },
                responsive: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            display: false
                        }
                    }]
                }
            }
        });
})

function refreshCount() {
    if(!chart || items.length === 0)
        return

    let itemDayCount = {}
    for(let i in items) {
        let date = new Date(items[i].item_createtime*1000).toDateString()

        if(date in itemDayCount) {
            itemDayCount[date] += 1
        } else {
            itemDayCount[date] = 1
        }
    }

    let itemDayCountArray = Object.keys(itemDayCount).map(function(key) {
        return [key, itemDayCount[key]];
    });

    itemDayCountArray = itemDayCountArray.sort((a,b) => {
        return (new Date(a[0])).getTime() - (new Date(b[0])).getTime()
    })

    let dayLabelArray = itemDayCountArray.map(v => v[0])
    let dayCountArray = itemDayCountArray.map(v => v[1])

    chart.data = {
        labels: dayLabelArray,
        datasets: [{
            data: dayCountArray,
            borderWidth: 2
        }]
    }
    chart.update()
}

</script>

<canvas bind:this={chartElem} width="400" height="250"></canvas>